'use client';

import { useClickWithAnalytics } from '@/analytics/useClickWithAnalytics';
import { usePageEvent } from '@/analytics/usePageEvent';
import {
  ErrorPage as BaseErrorPage,
  ErrorPageProps as BaseErrorPageProps,
} from '@soluto-private/mx-asurion-ui-react';
import { MouseEventHandler } from 'react';
import styles from './error-page.module.scss';

export type ErrorPageProps = Omit<BaseErrorPageProps, 'className'> & {
  pageName: string;
};

export const ErrorPage = ({ pageName, ...props }: ErrorPageProps) => {
  usePageEvent(pageName);

  const onClick = useClickWithAnalytics(
    'ButtonClick',
    props.action?.onClick as MouseEventHandler,
  );

  if (props.action) {
    props.action.onClick = onClick;
  }

  return (
    <div>
      <BaseErrorPage className={styles.errorPage} {...props} />
    </div>
  );
};
